import {Component, computed, inject} from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {ActivityTypeSummary} from '../../../../../../../api';
import {ActivityTypeFormModel} from '../../../../../../features/timesheets/models/activity-type-form-model';
import {
  ActivityTypeQueryService
} from '../../../../../../features/timesheets/services/activity-type-query.service';
import {
  ActivityTypeCommandService
} from '../../../../../../features/timesheets/services/activity-type-command.service';
import {TextInput} from '../../../../../../components/text-input/text-input';
import {ElciaButton} from '../../../../../../components/buttons/button/button';

@Component({
  selector: 'elcia-timesheet-settings-activity-type',
  imports: [TextInput, ElciaButton, TranslatePipe],
  templateUrl: './timesheet-settings-activity-type.html',
})
export class TimesheetSettingsActivityType {

  private readonly queryService = inject(ActivityTypeQueryService);
  private readonly commandService = inject(ActivityTypeCommandService);

  activityTypeForms = computed(() => {
    const formArray = new FormArray<FormGroup<ActivityTypeFormModel>>([]);
    for (const activityType of this.queryService.activityTypes()) {
      const fg = this.createFormGroup(activityType);
      fg.disable();
      formArray.push(fg);
    }
    return formArray;
  });

  createForm = new FormGroup<Omit<ActivityTypeFormModel, 'id'>>({
    nameEn: new FormControl('', Validators.required),
    nameFr: new FormControl('', Validators.required),
    nameNl: new FormControl('', Validators.required),
  });

  private createFormGroup(activityType: ActivityTypeSummary): FormGroup<ActivityTypeFormModel> {
    return new FormGroup<ActivityTypeFormModel>({
      id: new FormControl(activityType.id),
      nameEn: new FormControl(activityType.nameEn ?? '', Validators.required),
      nameFr: new FormControl(activityType.nameFr ?? '', Validators.required),
      nameNl: new FormControl(activityType.nameNl ?? '', Validators.required),
    });
  }

  private getFormGroupById(id: number | null | undefined) {
    return this.activityTypeForms().controls.find(c => c.value.id === id);
  }

  toggleFormGroup(id: number | null | undefined) {
    const fg = this.getFormGroupById(id);
    if (!fg) return;
    if (fg.enabled) {
      if (fg.invalid) return;
      this.commandService.updateMutation.mutate({
        id: fg.value.id!,
        body: {
          nameFr: fg.value.nameFr,
          nameEn: fg.value.nameEn,
          nameNl: fg.value.nameNl,
        },
      });
      fg.disable();
    } else {
      fg.enable();
    }
  }

  deleteActivityType(id: number | null | undefined) {
    if (id == null) return;
    this.commandService.deleteMutation.mutate(id);
  }

  submitCreate() {
    if (this.createForm.invalid) return;
    this.commandService.createMutation.mutate(
      {
        nameFr: this.createForm.value.nameFr,
        nameEn: this.createForm.value.nameEn,
        nameNl: this.createForm.value.nameNl,
      },
      {onSuccess: () => this.createForm.reset()}
    );
  }
}
